require('es6-promise').polyfill();
require('isomorphic-fetch');

import moment from 'moment-timezone';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import routes from './routes';
import { configure } from './redux/configureStore';
import Storage from './Storage';
import Util from './Util';
import * as actions from './redux/actions';
import Api from './Api';
import $ from 'jquery';
// make it global variable
window.$ = $;

import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

const store = configure();
const history = syncHistoryWithStore(browserHistory, store);

let loadHostInfoList = false;
history.listen((location) => {
  let pathname = location.pathname || '';
  __DEBUG__ && console.log(Util.localDateTimeString(new Date()), 'route', pathname);

  loadHostInfoList = pathname.startsWith('/kiosk/') || pathname.startsWith('/server/');
  document.title = `${pathname}`;
});

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={routes}>
    </Router>
  </Provider>,
  document.getElementById('root-container')
);

let lastRenewCheck = new Date(1970, 0, 1);
function renewToken(forceRenew = false) {
  let hasValidToken = Storage.hasValidToken();
  if (!hasValidToken) {
    Api.logout();
    return;
  }

  // renew token every minute
  let shouldRenew = (new Date() - lastRenewCheck) > (60 * 1000);
  __DEBUG__ &&
    console.log(
      Util.localDateTimeString(new Date()),
      'lastRenewCheck is ' + lastRenewCheck.toLocaleTimeString(),
      'shouldRenew:',
      shouldRenew
    );

  if (forceRenew || shouldRenew) {
    lastRenewCheck = new Date();
    Api.renewToken().then(() => {
      // only load this on certain page
      if (loadHostInfoList) {
        store.dispatch(actions.getHostInfoList(false));
      }
      console.log('token renewed!');
    });
  }
}

let onMouseMoveTimeout;
$(document).mousemove(() => {
  // throttle on mouse move event (not to fire on every mouse move)
  if (!onMouseMoveTimeout) {
    onMouseMoveTimeout = setTimeout(() => {
      renewToken(false);
      onMouseMoveTimeout = null;
    }, 5000);
  }
});

document.addEventListener('visibilitychange', () => {
  renewToken(true);
});

if (Storage.hasValidToken()) {
  // workaround for page refresh
  store.dispatch(actions.loginAndRenewToken()).then(() => {
    store.dispatch(actions.getHostInfoList(true));
    lastRenewCheck = new Date();
  });
}

if (__DEV__) {
  window.dash = {
    Api: Api,
    HttpClient: require('./HttpClient'),
    store,
    actions,
    history,
    Storage,
    Util,
    moment,
  };
}



// WEBPACK FOOTER //
// ./src/main.js